import type {
  AxiosRequestConfig,
  DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';
import { webviewHttpClient } from '@/app/[locale]/(m)/components/auth/webview-http-client';

export interface AddCommentParams {
  order_code: string;
  comment: string;
}

export const addCommentFn = async (
  token: string,
  params: AddCommentParams,
  config: AxiosRequestConfig = {}
): Promise<any> => {
  const response = await webviewHttpClient.post<any>(
    apiRoutes.ahafood.web_view.add_comment(params.order_code),
    params,
    {
      ...config,
      headers: {
        ...config.headers,
        Authorization: token ? `Bearer ${token}` : '',
      },
    }
  );

  return response.data;
};

export const useAddComment = (
  token: string,
  options?: UseMutationOptions<any, DefaultQueryError, AddCommentParams>
) =>
  useMutation<any, DefaultQueryError, AddCommentParams>({
    mutationFn: (params) => addCommentFn(token, params),
    ...options,
  });
